import { Button, Select, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, useLoaderData, useNavigate, useParams } from 'react-router-dom';
import Pagination from '../../globalComponents/Pagination';
import Axios from '../utils/axios';
import Filters from '../../globalComponents/Filters';



const columns = [
  {
    title: 'Expense Date',
    dataIndex: 'expense_date',
    key: 'expense_date',
    className: 'whitespace-nowrap font-medium dark:text-white',
    render: (_, record) => <span>{new Date(record.expense_date).toDateString()}</span>
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    className: 'whitespace-nowrap font-medium dark:text-white',
    width: '40%'
  },
  {
    title: 'Employee',
    dataIndex: 'employee',
    key: 'employee',
    className: 'whitespace-nowrap font-medium dark:text-white',
    // width: '20%'
  },
  {
    title: 'Paid By',
    dataIndex: 'paid_by',
    key: 'paid_by',
    className: 'whitespace-nowrap font-medium dark:text-white',
    width: '10%'
  },
  {
    title: 'Total',
    dataIndex: 'total_amount',
    key: 'total_amount',
    className: 'whitespace-nowrap font-medium dark:text-white',
    width: '5%',
    render: (_, record) => <span>{record.total_amount.$numberDecimal}</span>

  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    className: 'whitespace-nowrap font-medium dark:text-white',
    width: '5%'
  },
  {
    title: 'Action',
    key: 'operation',
    // width: '20%',
    fixed: 'right',
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/expense/expenses/'+record.seo}>
        EDIT
      </Link>
    )
  }
]


const items = [
  {key: 'to_submit', label: 'To Submit'},
  {key: 'submitted', label: 'To Approve'},
  {key: 'refused', label: 'Refused'}
]

const Expenses = () => {
  const loader = useLoaderData();
  const navigate = useNavigate();
  const params = useParams();
  let params_ = params.seo ? JSON.parse(params?.seo) : null;
  const [expenses, setExpenses] = useState(loader);

  const [search, setSearch] = useState('');
  const [selectedFilters, setSelectedFilters] = useState(params_ !== null ? [params_.status] : []);
  const [searchBy, setSearchBy] = useState('transfer');
  const [paginations, setPaginations] = useState({pageSize: 100, page: 1});

  const onRow = (record, rowIndex) => {
    return {
      onClick: () => navigate('/expense/expenses/'+record.seo)
    };
  };


  const handleChange = (e, option) => {
    let value_ = e.map(item => item.toLowerCase());
    setSearch(value_)
  }


  async function fetchInfo(filters, pagination_) {

    return Axios(`expenses/search?filter=${JSON.stringify(filters)}&&pagination=${JSON.stringify(pagination_)}`)
      .then((response) => response.data)
      .then((res) => {
        setExpenses(res);
        // setPaginations({...paginations, total: res.totalRows})
      
      });
  }


  useEffect(() => {
    const offset = (paginations.page - 1) * 100;
    let pagination_ = {offset};
    // let filters = {search: {by: params_ !== null ? 'op' : searchBy, values: params_ !== null ? [params_.seo] : search, filters: params_ !== null ? [params_.status] : selectedFilters}};
    let filters = params_ !== null ? [params_.status] : selectedFilters;
    fetchInfo(filters, pagination_);

  },[selectedFilters, paginations])


  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Expenses</h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/expense/expenses/new'} className='w-full'>New</Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-between'>
            <Filters items={items} setSelectedFilters={setSelectedFilters} selectedFilters={selectedFilters}/>
            <Pagination paginations={paginations} setPaginations={setPaginations} total={expenses.totalRows} />
          </div>
        </div>
      </div>
      <Table
        rowKey={'description'}
        onRow={onRow}
        rowClassName={'hover:cursor-pointer'}
        dataSource={expenses.all}
        columns={columns}
        // scroll={{ x: 1500 }}
        pagination={false}
      />
    
    </div>
  )
}

export default Expenses;